<template>
	<div class="banner-split2-reservation-play" style="line-height: 1">
		<div class="row-grid">
			<div class="ratio-cover">
				<Slider :data="sliderData"></Slider>
			</div>
			<div class="ratio-cover">
				<div class="description">
					<h3 class="reservation-text">
						從街頭到世界劇場&emsp;最斜槓的藝術基地
					</h3>
					<br />
					<p class="content">
						鄰近冬山河、座落於利澤老街旁的「利澤國際偶戲藝術村」，為宜蘭老穀倉整建活化而成的建築群，也是全台唯一的當代偶戲藝術園區。擁有偶戲展示館、專業製偶工廠、藝術家工作室、排練場等的偶戲村，為「無獨有偶工作室劇團」的藝術基地，也是海內外偶戲藝術工作者，進行研發創作、偶戲交流及展演、教育推廣等的迷人創意空間。
					</p>
					<br />
					<p class="content">
						偶戲村致力於推廣大眾偶戲藝術欣賞，特別規劃一系列能輕鬆入門偶戲的參訪、互動式體驗，歡迎大手牽小手一同體驗，與偶們的美好時光！
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Slider from "@/components/slider";
export default {
	name: "bannerSplit2ReservationPlay",
	data() {
		return {
			sliderData: [
				"/static/assets/reservation/play/slide1.jpg",
				"/static/assets/reservation/play/slide2.jpg",
				"/static/assets/reservation/play/slide3.jpg",
				"/static/assets/reservation/play/slide4.jpg",
				"/static/assets/reservation/play/slide5.jpg",
			],
		};
	},
	methods: {},
	props: {
		ch: String,
		en: String,
	},
	components: {
		Slider,
	},
};
</script>

<style lang="scss" scoped>
.reservation-title {
	font-size: 22px;
}
.reservation-text {
	font-size: 18px;
}
.row-grid {
	width: 100%;
	overflow: hidden;
	display: flex;

	// @media screen and (min-width: 769px) {
	// 	> * {
	// 		max-height: 600px;
	// 	}
	// }

	.ratio-cover {
		position: relative;
		width: 100%;
	}

	.description {
		background: #000;
		padding: 5%;
		color: #fff;
		overflow: auto;
		line-height: 1.5;
	}

	@media screen and (min-width: 769px) {
		.ratio-cover {
			flex: 1;
			&::before {
				content: "";
				display: block;
				width: 100%;
				padding-top: 60%;
			}
			> * {
				position: absolute;
				display: block;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}
			.img-fluid {
				object-fit: cover;
			}
		}
		.ratio-cover:first-child {
			aspect-ratio: 4 / 3;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/banner/banner_split2_reservation_play.vue